export const CLIENT_CONNECTED = "connected";
export const CLIENT_DISCONNECTED = "disconnected";
export const CLIENT_FEED_PREMATCH = "prematch";
export const CLIENT_FEED_LIVE = "live";
export const CLIENT_SUBSCRIBE_EVENT = "event";
export const CLIENT_SUBSCRIBE_TOURNAMENT = "tournament";
export const CLIENT_SUBSCRIBE_MARKET = "market";
export const CLIENT_CALENDAR = "calendar";
export const CLIENT_CALENDAR_TREE = "calendar_tree";
export const CLIENT_WITHDRAWAL = "withdrawal";
export const CLIENT_WITHDRAWAL_BATCH = "withdrawal_batch";
export const CLIENT_DEPOSIT = "deposit";
export const CLIENT_DEPOSIT_BATCH = "deposit_batch";
export const CLIENT_TICKET = "ticket";
export const CLIENT_WALLET = "wallet";
export const CLIENT_CHAT_MESSAGE = "chat_message";
export const CLIENT_EXCHANGE_RATES_LATEST = "exchange_rates_latest";
export const CLIENT_EXCHANGE_RATES_TIME = "exchange_rates_time";
export const CLIENT_TOP_GAMES = "top";
export const CLIENT_UPCOMING_GAMES = "upcoming";

export const CLIENT_PING = "ping";

export const SERVER_UNSUBSCRIBE = "unsubscribe";
export const SERVER_CONNECT = "connect";
export const SERVER_CONNECTED = "connected";
export const SERVER_FEED_PREMATCH = "prematch";
export const SERVER_FEED_LIVE = "live";
export const SERVER_SUBSCRIBE_EVENT = "event";
export const SERVER_GAME_EVENT = "event";
export const SERVER_SUBSCRIBE_TOURNAMENT = "tournament";
export const SERVER_TOURNAMENT = "tournament";
export const SERVER_SUBSCRIBE_MARKET = "market";
export const SERVER_MARKET = "market";
export const SERVER_CALENDAR = "calendar";
export const SERVER_WITHDRAWAL = "withdrawal";
export const SERVER_WITHDRAWAL_BATCH = "withdrawal_batch";
export const SERVER_DEPOSIT = "deposit";
export const SERVER_DEPOSIT_BATCH = "deposit_batch";
export const SERVER_TICKET = "ticket";
export const SERVER_WALLET = "wallet";
export const SERVER_CHAT_MESSAGE = "chat_message";
export const SERVER_CHAT_MESSAGE_UNSUBSCRIBE = "chat_message";
export const SERVER_EXCHANGE_RATES_LATEST = "exchange_rates_latest";
export const SERVER_EXCHANGE_RATES_TIME = "exchange_rates_time";
export const SERVER_TOP_GAMES = "top";
export const SERVER_UPCOMING_GAMES = "upcoming";

export const SERVER_ERROR = "error";
export const SERVER_PING = "ping";
export const SERVER_PONG = "pong";

export type IServerUnsubscribeEvent = typeof SERVER_UNSUBSCRIBE;
export type IServerConnectEvent = typeof SERVER_CONNECT;
export type IServerConnectedEvent = typeof SERVER_CONNECTED;
export type IServerFeedPrematchEvent = typeof SERVER_FEED_PREMATCH;
export type IServerFeedLiveEvent = typeof SERVER_FEED_LIVE;
export type IServerSubscribeEvent = typeof SERVER_SUBSCRIBE_EVENT;
export type IServerGameEvent = typeof SERVER_GAME_EVENT;
export type IServerSubscribeTournament = typeof SERVER_SUBSCRIBE_TOURNAMENT;
export type IServerTournament = typeof SERVER_TOURNAMENT;
export type IServerSubscribeMarket = typeof SERVER_SUBSCRIBE_MARKET;
export type IServerMarket = typeof SERVER_MARKET;
export type IServerCalendar = typeof SERVER_CALENDAR;
export type IServerWithdrawalEvent = typeof SERVER_WITHDRAWAL;
export type IServerWithdrawalBatchEvent = typeof SERVER_WITHDRAWAL_BATCH;
export type IServerDepositEvent = typeof SERVER_DEPOSIT;
export type IServerDepositBatchEvent = typeof SERVER_DEPOSIT_BATCH;
export type IServerTicketEvent = typeof SERVER_TICKET;
export type IServerWalletEvent = typeof SERVER_WALLET;
export type IServerChatMessageEvent = typeof SERVER_CHAT_MESSAGE;
export type IServerExchangeRatesLatestEvent = typeof SERVER_EXCHANGE_RATES_LATEST;
export type IServerExchangeRatesTimeEvent = typeof SERVER_EXCHANGE_RATES_TIME;
export type IServerTopGamesEvent = typeof SERVER_TOP_GAMES;
export type IServerUpcomingGamesEvent = typeof SERVER_UPCOMING_GAMES;
export type IServerErrorEvent = typeof SERVER_ERROR;
export type IServerPingEvent = typeof SERVER_PING;
